module.exports = __webpack_public_path__ + "static/media/fish.2e49b815.svg";